import _ from 'lodash';
import $ from "jquery";
import moment from 'moment';
import excelExport from 'table2excel/dist/table2excel';
import csvExport from 'table2csv/dist/table2csv';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import FooTable from 'footable';

class ReportsController {
  constructor($rootScope, $http, toastr) {
    "ngInject";
    this.name = 'reports';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.reports = [];

    let self = this;
    this.$http.get($rootScope.apiHost+"/api/reports/", {withCredentials: true}).then(function (success) {
      self.reports = success.data;
    });


    let style = [
      {textCls: 'text-info', btnCls: 'btn-info'},
      {textCls: 'text-success', btnCls: 'btn-success'},
      {textCls: 'text-warning', btnCls: 'btn-warning'},
      {textCls: 'text-danger', btnCls: 'btn-danger'}
    ]



  }






}

export default ReportsController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/reports.controller.js